import React from 'react';
import { format } from 'date-fns';
import { parseLocalDate } from '../../lib/utils';

// Helper to format decimal hours to "Xh Ym" display
const formatHours = (hours) => {
  if (!hours || hours === 0) return '0h';
  const totalMinutes = Math.round(hours * 60);
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hrs === 0) return `${mins}m`;
  if (mins === 0) return `${hrs}h`;
  return `${hrs}h ${mins}m`;
};

export default function TimesheetInfoSection({ timesheet }) {
  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return '—';
    try {
      return format(parseLocalDate(dateStr), 'MMM d, yyyy');
    } catch {
      return dateStr;
    }
  };

  // Calculate status badge color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return 'bg-green-100 text-green-700';
      case 'submitted': return 'bg-blue-100 text-blue-700';
      case 'rejected': return 'bg-red-100 text-red-700';
      case 'paid': return 'bg-green-100 text-green-700';
      default: return 'bg-slate-100 text-slate-700';
    }
  };

  return (
    <div className="mb-4">
      {/* Title */}
      <div className="mb-3 text-center">
        <h2 className="text-lg font-semibold text-slate-900">Weekly Timesheet</h2>
        <p className="text-sm text-slate-500">Week {timesheet.week_number}</p>
      </div>
      
      {/* Info Grid - 3 columns */}
      <div className="grid grid-cols-3 gap-4 text-sm">
        {/* Employee */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Employee</p>
          <p className="font-semibold text-slate-900">{timesheet.employee_name || timesheet.user_name}</p>
          <span className={`inline-block mt-1 px-2 py-0.5 rounded text-[10px] font-medium ${getStatusColor(timesheet.status)}`}>
            {timesheet.status || 'Draft'}
          </span>
        </div>
        
        {/* Period */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Period</p>
          <p className="font-medium text-slate-700">{formatDateDisplay(timesheet.week_start)}</p>
          <p className="text-xs text-slate-500">to {formatDateDisplay(timesheet.week_end)}</p>
        </div>
        
        {/* Total Hours */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Total Hours</p>
          <p className="text-2xl font-bold text-amber-600">{formatHours(timesheet.total_hours)}</p>
        </div>
      </div>
    </div>
  );
}
